import client from "../../client/client";

class QuickAccessService {
	filterRequirements({ documentId }, payload, cancelToken) {
		return client.put(`/quickaccess/documents/${documentId}/filter`, { payload, config: { cancelToken } });
	}

	getFilterResultsInDocumentPages({ documentId, startNumber, endNumber }, payload, cancelToken) {
		return client.post(
			`/quickaccess/documents/${documentId}/start-page/${startNumber}/end-page/${endNumber}/search`,
			{
				payload,
				config: { cancelToken },
			}
		);
	}

	getInfoVersionList(cancelToken) {
		return client.get("/quickaccess/info-version", {
			config: { cancelToken },
		});
	}
}

export default new QuickAccessService();
